const VEHICLE_INFO = {
  year: "Year",
  model: "Model",
  make: "Make",
  VIN: "VIN",

  color: "Color",
  mileage: "Mileage",
  plateNumber: "Plate Number",

  owner: "Owner",
  registeredTo: "Registered to?",
  priorDamage: "Was there any prior damage to the vehicle before the accident?",
  priorDamageDescription: "Prior Damage Description",

  describeDamage: "Please describe the damage to your vehicle:",
  isAirbagDeployed: "Did the vehicle airbags deploy?",
  isDrivable: "Is the vehicle in a condition where it cannot be driven?",
  isRoofBuckled:
    "Is the roof of this vehicle buckled and/or did the vehicle roll over?",
  isTowed: "Was this vehicle towed?",
};

const CURE_DRIVER_INFO = {
  FirstName: "First Name",
  LastName: "Last Name",
  DOB: "Date of birth",

  DLNumber: "Driver's License Number",
  DLState: "Driver's License State",
  relationToPolicyHolder: "Relationship to the Policyholder",
  PhoneNumber: "PhoneNumber",
  EmailAddress: "EmailAddress",

  StreetAddress: "Street Address",
  ApartmentNo: "Apartment #",
  City: "City",
  State: "State",
  ZipCode: "Zip Code",
};

const LOSS_INFORMATION = {
  StreetAddress: "StreetAddress",
  ApartmentNo: "Apartment #",
  City: "City",
  State: "State",
  ZipCode: "ZipCode",

  descriptionOfAccident: "Description of accident",

  policeContacted: "Police contacted",
  policeDistrict: "Police District/Township",
  reportNumber: "Case/Report Number",
};

const ADDITIONAL_INFO = {
  anyOtherVehiclesInvolved:
    "Where there any other vehicles or property damaged in the loss?",
  wereThereAnyPassengersInVehicle: "Were there any passengers in your vehicle?",
  wereThereAnyInjuriesInLoss: "Was anyone else injured in this loss?",
}

const PASSENGER = {
  FirstName: "First Name",
  LastName: "Last Name",
  PhoneNumber: "PhoneNumber",
  StreetAddress: "StreetAddress",
  ApartmentNo: "Apartment #",
  City: "City",
  State: "State",
  ZipCode: "ZipCode",
};

const INJURED_PERSON = {
  FirstName: "First Name",
  LastName: "Last Name",
  PhoneNumber: "PhoneNumber",
  StreetAddress: "StreetAddress",
  ApartmentNo: "Apartment #",
  description: "Description of Injury:",
  City: "City",
  State: "State",
  ZipCode: "ZipCode",
};

const QUESTIONS = {
  VEHICLE_INFO, CURE_DRIVER_INFO, LOSS_INFORMATION, PASSENGER, INJURED_PERSON, ADDITIONAL_INFO
}

export { QUESTIONS };
